import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/angry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM248 312C214.4 312 182.8 326.8 161.2 352.6 152.7 362.8 154.1 377.9 164.3 386.4S189.6 393.6 198.1 383.4C222.9 353.7 273.1 353.7 297.9 383.4 306 393.1 321.1 395.3 331.7 386.4 341.9 377.9 343.2 362.8 334.8 352.6 313.2 326.8 281.6 312 248 312zM200 240C210.3 240 219.9 233.3 223 222.9 226.8 210.2 219.6 196.8 206.9 193L126.9 169C114.1 165.1 100.8 172.4 97 185.1 93.2 197.8 100.4 211.2 113.1 215L141.3 223.5C138.2 228.4 136 233.9 136 240.1 136 257.8 150.3 272.1 168 272.1S200 257.7 200 240zM399 185.1C395.2 172.4 381.9 165.2 369.1 169L289.1 193C276.4 196.8 269.2 210.2 273 222.9 276.1 233.3 285.7 240 296 240 296 257.7 310.3 272 328 272S360 257.7 360 240C360 233.8 357.8 228.3 354.7 223.4L382.9 214.9C395.6 211.2 402.8 197.8 399 185.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/angry.js
// module id = gT/T
// module chunks = 144